import { render } from "./Home2.vue?vue&type=template&id=2de3d068"
import script from "./Home2.vue?vue&type=script&lang=js"
export * from "./Home2.vue?vue&type=script&lang=js"

import exportComponent from "E:\\dipto_projects\\asset_tracker\\aqc-asset-tracker-fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__